import { CollectionReturnValue } from 'cytoscape';

interface Props {
  source: CollectionReturnValue;
  targets: CollectionReturnValue;
  maxDepth?: number;
}

// check if there are multiple paths from source to any of the targets
export function cyHasMultiplePaths({
  source,
  targets,
  maxDepth,
}: Props): boolean {
  const maxDepthValue = maxDepth || Infinity;
  let pathCount = 0;

  function dfs(
    current: CollectionReturnValue,
    visited: Set<string>,
    depth: number
  ): boolean {
    if (depth > maxDepthValue) return false;

    // If current node is a target, increment path count
    if (targets.contains(current)) {
      pathCount += 1;
      // Stop if we found more than one path
      if (pathCount > 1) return true;
      // Do not return false here: continue exploration for more paths
    }

    // Explore neighbors
    let foundMultiple = false;
    current
      .neighborhood()
      .nodes()
      .forEach((neighbor: CollectionReturnValue) => {
        if (!visited.has(neighbor.id())) {
          const newVisited = new Set(visited).add(neighbor.id());
          // Stop exploration if multiple paths are found
          if (dfs(neighbor, newVisited, depth + 1)) {
            foundMultiple = true;
          }
        }
      });

    return foundMultiple;
  }

  const initialVisited = new Set<string>([source.id()]);
  return dfs(source, initialVisited, 1);
}
